import { Widget, getWidgetProps, WPSClient, StorefrontOutput, withArgs, safeBool } from 'DVWebNodeUtils'
import StorefrontComponent from './shared/containers/Storefront';


const getProps: getWidgetProps<StorefrontOutput> = global.__SERVER__ === true
  ? async ({ context, contentType, contentId, filters, isElcano, node, targetId,
    startIndex, pageNumber, pageSize, serviceToken,
  }, api) => {

    const parsedPageNumber = pageNumber && parseInt(pageNumber, 10)
    const parsedPageSize = pageSize && parseInt(pageSize, 10)
    const parsedStartIndex = startIndex && parseInt(startIndex, 10)

    const wpsClient = new WPSClient(api)
    const response = await wpsClient.Storefront({
      context: context,
      contentType: contentType,
      contentID: contentId,
      pageNumber: parsedPageNumber,
      pageSize: parsedPageSize,
      filters: filters,
      serviceToken: serviceToken,
      nodeID: `${node}`,
      startIndex: parsedStartIndex,
      isElcano: safeBool(isElcano),
      targetId: targetId
    });
    return response;
  } : undefined;

export const Storefront: Widget<StorefrontOutput> = {
  name: 'storefront',
  getProps,
  Component: withArgs(StorefrontComponent) as React.ComponentType<StorefrontOutput>
}